"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCollectorContentFactory = exports.EventCollectorContainerFactory = void 0;
var web_ui_framework_1 = require("@gruposantander/web-ui-framework");
Object.defineProperty(exports, "EventCollectorContainerFactory", { enumerable: true, get: function () { return web_ui_framework_1.EventCollectorContainerFactory; } });
Object.defineProperty(exports, "EventCollectorContentFactory", { enumerable: true, get: function () { return web_ui_framework_1.EventCollectorContentFactory; } });
//# sourceMappingURL=index.js.map